// Shared visual constants for the redesigned student experience.
// Pure presentation — no data fetching, no business logic.

export const pageGradientBackground =
  "radial-gradient(900px 360px at 86% 6%, rgba(14,165,233,0.16), transparent 62%)," +
  "radial-gradient(720px 300px at 100% 0%, rgba(219,244,255,0.72), transparent 68%)," +
  "linear-gradient(180deg, #ffffff 0%, #f8fbff 58%, #ffffff 100%)";

export const cardShadow = "0 10px 24px rgba(15,23,42,0.06)";

// Mirrors TeacherExercises.js's MODE_LABELS — same wording, both sides of
// the app must describe an exercise's assistance type identically.
export const EXERCISE_MODE_LABELS = {
  hints: "تلميحات فقط",
  guided: "حل موجّه",
  direct: "إجابة مباشرة",
};

export const AI_STATUS_COLORS = {
  active: { bg: "#e7f7ec", fg: "#16a34a" },
  inactive: { bg: "#eef1f6", fg: "#64748b" },
};

export const ASSISTANCE_TYPE_COLORS = {
  hints: { bg: "#e8f0fe", fg: "#2f6fed" },
  guided: { bg: "#e8f0fe", fg: "#2f6fed" },
  direct: { bg: "#fff1e3", fg: "#ea7317" },
};
